import { makeAutoObservable } from 'mobx';

export class SnoozeStore {
  isCalendarOpen = false;
  openDropdownId: string | null = null;
  selectedDate = '';
  selectedTime = '00:00';
  buttonHeight = 0;
  position: 'top' | 'bottom' = 'bottom';
  alignment: 'left' | 'center' | 'right' = 'left';
  dropdownTopOffset = 0;

  constructor() {
    makeAutoObservable(this);
  }

  setIsCalendarOpen(value: boolean) {
    this.isCalendarOpen = value;
  }

  setOpenDropdownId(value: string | null) {
    this.openDropdownId = value;
  }

  setSelectedDate(value: string) {
    this.selectedDate = value;
  }

  setSelectedTime(value: string) {
    this.selectedTime = value;
  }

  setButtonHeight(value: number) {
    this.buttonHeight = value;
  }

  setPosition(value: 'top' | 'bottom') {
    this.position = value;
  }

  setAlignment(value: 'left' | 'center' | 'right') {
    this.alignment = value;
  }

  setDropdownTopOffset(value: number) {
    this.dropdownTopOffset = value;
  }

  reset() {
    this.isCalendarOpen = false;
    this.selectedDate = '';
    this.selectedTime = '00:00';
    this.openDropdownId = null;
  }
}
